import React from 'react';
import PropTypes from 'prop-types';
import styles from './infobox.scss';

const propTypes = {
  children: PropTypes.node,
};

const InfoBox = ({ children }) => (
  <div className={styles.infoBox}>
    <i className="far fa-info-circle" />
    {' '}
    {children}
  </div>
);

InfoBox.propTypes = propTypes;
export default InfoBox;
